import { getJSON, postJSON } from '@folklore/fetch';

// ============================================================================
// Request Utilities
// ============================================================================
// API request helpers with locale support

declare const LOCALE: string | undefined;

const locale = typeof LOCALE !== 'undefined' ? LOCALE : null;

const getLocaleHeaders = (): Record<string, string> | null =>
    locale !== null
        ? {
              'Accept-Language': locale,
          }
        : null;

const getRequestOptions = () => ({
    credentials: 'same-origin' as RequestCredentials,
    headers: {
        ...getLocaleHeaders(),
    },
});

// ============================================================================
// GET Requests
// ============================================================================

export const loadPage = <T = unknown>(url: string): Promise<T> =>
    getJSON<T>(url, getRequestOptions());

export const loadList = <T = unknown>(url: string): Promise<T> =>
    getJSON<T>(url, getRequestOptions());

export const loadNewArticle = <T = unknown>(url: string): Promise<T> =>
    getJSON<T>(url, getRequestOptions());

export const loadFiltersOptions = <T = unknown>(url: string): Promise<T> =>
    getJSON<T>(url, getRequestOptions());

export const loadVenues = <T = unknown>(url: string): Promise<T> =>
    getJSON<T>(url, getRequestOptions());

export const loadVenueEvents = <T = unknown>(url: string): Promise<T> =>
    getJSON<T>(url, getRequestOptions());

// ============================================================================
// POST Requests
// ============================================================================

interface NewsletterData {
    email: string;
}

export const subscribeNewsletter = (url: string, email: string): Promise<unknown> =>
    postJSON<NewsletterData>(
        url,
        {
            email,
        },
        getRequestOptions(),
    );

interface MessageData {
    email: string;
    message: string;
    newsletter: boolean;
}

export const sendMessage = (
    url: string,
    email: string,
    message: string,
    newsletter: boolean = true,
): Promise<unknown> =>
    postJSON<MessageData>(
        url,
        {
            email,
            message,
            newsletter,
        },
        getRequestOptions(),
    );
